export const WORKSPACE_MODES = {
  GESTION: 'gestion',
  SUPERADMIN: 'superadmin',
  PARTNERS: 'partners',
  BLOG: 'blog'
};

const VALID_WORKSPACE_MODES = new Set(Object.values(WORKSPACE_MODES));

const normalizeWorkspaceMode = mode => {
  const normalizedMode = String(mode || '').trim().toLowerCase();
  return VALID_WORKSPACE_MODES.has(normalizedMode)
    ? normalizedMode
    : WORKSPACE_MODES.GESTION;
};

export const getWorkspaceMode = userData => {
  if (userData?.user?.is_super_admin) {
    return WORKSPACE_MODES.SUPERADMIN;
  }

  const profileMode = normalizeWorkspaceMode(userData?.profile?.workspace_mode);
  const workspaceMode = normalizeWorkspaceMode(userData?.workspace?.mode);

  if (profileMode !== WORKSPACE_MODES.GESTION) {
    return profileMode;
  }

  if (workspaceMode !== WORKSPACE_MODES.GESTION) {
    return workspaceMode;
  }

  return workspaceMode;
};

export const isRouteVisibleForMode = (mode, allowedModes) => {
  if (mode === WORKSPACE_MODES.SUPERADMIN) {
    return true;
  }
  if (!Array.isArray(allowedModes) || !allowedModes.length) {
    return true;
  }
  return allowedModes.includes(mode);
};

export const getDefaultWorkspaceRoute = mode => {
  switch (mode) {
    case WORKSPACE_MODES.SUPERADMIN:
      return '/super-admin';
    case WORKSPACE_MODES.PARTNERS:
      return '/partners';
    case WORKSPACE_MODES.BLOG:
      return '/blog';
    default:
      return '/dashboard';
  }
};
